import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  display: none;

  ${media.medium`
    display: flex;
    flex-direction: column;
    order: 3;
    margin: -30px 0 0 0;
  `}
`;
